import { Container, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import Buscador from '../../../actions/ui/Buscador';

export const BuscadorAfiliadosExternos = (props) => {

    const [value, setValue] = useState(props.afiliadoExternoTemp);

    useEffect(() => {
        props.setAfiInexistente();
        props.setAfiliadoExternoTemp(value);
        props.setEnableCheckAfiInexistente(false);
    }, [value])

    const tipoBusqueda = "Todos"

    const altaBaja = "Todos"

    return (
        <React.Fragment>
            <Grid
                container
                spacing={3}
                style={{
                    display: "flex",
                    justifyContent: !props.hideTitle ? "center" : "",
                    marginTop: props.integracion && !props.gestion && 10
                }}
            >
                {!props.hideTitle &&
                    <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            component="h1"
                            variant="h5"
                            style={{
                                color: "#FAFAFA",
                            }}
                        >
                            Buscar
                        </Typography>
                    </Grid>
                }
                <Grid item xs={!props.hideTitle ? 6 : 12} style={{ flexBasis: !props.hideTitle ? "auto" : "" }}>
                    <Container
                        style={{
                            padding: 3,
                            marginTop: 5,
                            margin: 5,
                        }}

                    >
                        <Buscador
                            fieldsDisabled={props.disabled}
                            value={value}
                            variant="outlined"
                            setValue={(val) => {
                                setValue(val)
                            }}
                            label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                            noOptionText={"No se encuentra beneficiaria/o"}
                            endpoint={(texto) =>
                                `AfiliadosExternos/traerPorNombreoDNIoNroAfiExterno/${texto}/${tipoBusqueda}/${altaBaja}`
                            }
                            getOptionLabel={(option) =>
                                `${option?.apellido_y_nombre} ${option?.carnet} ${option?.cuil} ${option?.nro_doc}`
                            }
                            renderOption={(option) => (
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span
                                        style={
                                            option?.fecha_baja === null
                                                ? { color: "green" }
                                                : { color: "red" }
                                        }
                                    >
                                        {`${option?.apellido_y_nombre}`}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: 12,
                                        }}
                                    >
                                        {" "}
                                        {`Nro Afi:${option?.carnet} - CUIL:${option?.cuil}`}
                                    </span>
                                </div>
                            )}
                        />
                    </Container>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
